import Divider from 'antd/lib/divider'

import 'antd/lib/divider/style'

export * from 'antd/lib/divider'

export default Divider
